import React from 'react'
import PropTypes from 'prop-types'

import PreviewTextFieldSkeleton from '../PreviewTextFieldSkeleton'

import { renderTextWithEmoji } from '../../../../helpers/other'

import { AD_TEXT, TEXT_BLANK, TEXT_ENTER, TEXT_OPTION } from '../../../../../forms/Facebook/AdForms/fields'

import useStyles from './styles'

function AdPrimaryText({ elementInProgress, formikValues }) {
  const classes = useStyles()

  const adPrimaryTextInProgress = elementInProgress === TEXT_OPTION
  const leaveItBlank = formikValues[TEXT_OPTION] === TEXT_BLANK
  const showText = formikValues[TEXT_OPTION] === TEXT_ENTER
  const adText = formikValues[AD_TEXT]

  if (leaveItBlank) {
    return ''
  } else if (showText && adText) {
    return renderTextWithEmoji(adText)
  } else {
    return (
      <PreviewTextFieldSkeleton
        isInProgress={adPrimaryTextInProgress}
        count={3}
        className={classes.skeletonPrimaryText}
      />
    )
  }
}

AdPrimaryText.propTypes = {
  elementInProgress: PropTypes.string,
  formikValues: PropTypes.object
}

export default AdPrimaryText
